module.exports = __webpack_public_path__ + "img/zizhi.04246990.png";